export const tallyPrimeServerData = [
    {
      img: "../images/TallyPrimeServer/high-concurrency.png",
      alt: "High Concurrency",
      title: "High Concurrency",
      strong: "Performing operations in a frictionless environment",
      description: `Multiple users will be able to simultaneously load companies, save transactions, export reports, print reports, import data, take backup and perform other data related activities without experiencing any downtime. This will directly result in optimal utilization of man hours as the velocity at which a task gets completed will increase. Further, the users will be able to seamlessly work on the same data. Your Data will always be real-time, consistent, and accurate.`,
      reverse: false
    },
    {
      img: "../images/TallyPrimeServer/secureddesign.png",
      alt: "Secured by design",
      title: "Secured by design",
      strong: "Providing controlled access to data files",
      description: `When data files are managed through Tally Server, the location of the data on the server is not required. The name of the data server is sufficient to access and operate Tally. Operations over the company data like backup and restore are controlled with server level permissions available with authorization only. This ensures better control over user’s access to data.`,
      reverse: true
    },
    {
      img: "../images/TallyPrimeServer/high-reliability.png",
      alt: "High Reliability",
      title: "High Reliability",
      strong: "Minimizing instances of system unavailability",
      description: `Continue recording transactions or viewing reports while taking backup with no compromise on speed or access or accuracy. It also limits discrepancies at the client end to the client systems and ensures that neither data on the server nor the operations of other users get impacted. Thus, improves work productivity and business performance by avoiding disruption of work and ensuring zero downtime.`,
      reverse: false
    },
    {
      img: "../images/TallyPrimeServer/optimization.png",
      alt: "Business Process Optimization",
      title: "Business Process Optimization",
      strong: "Increased Productivity & Business Performance",
      description: `A comprehensive monitoring capability allows authorized users to manage user sessions, such as who is logged in and activities in progress. Also, with the ability to track, monitor user activities /sessions and even disconnect users, if required, it helps to optimize processes or system usage for enhanced productivity.`,
      reverse: true
    }
  ];
  
  export const faqData = [
    {
      question: "High concurrency – Work without interruptions",
      answer:
        "Multiple users will be able to simultaneously load companies, save transactions, export reports, print reports, import data, take backup and perform other data related activities without experiencing any downtime. This will directly result in optimal utilization of man hours as the velocity at which a task gets completed will increase. Further, the users will be able to seamlessly work on the same data. Your Data will always be real-time, consistent, and accurate."
    },
    {
      question: "Secured by design – Controlled access to data files",
      answer:
        "When data files are managed through TallyPrime Server, the location of the data on the server is not required. The name of the data server is sufficient to access and operate TallyPrime. Operations over the company data like backup and restore are controlled with server level permissions available with authorization only. This ensures better control over user’s access to data."
    },
    {
      question: "High reliability – Minimizing system downtime for uninterrupted operations",
      answer:
        "Continue recording transactions or viewing reports while taking backup with no compromise on speed or access or accuracy. It also limits discrepancies at the client end to the client systems and ensures that neither data on the server nor the operations of other users get impacted. Thus, improves work productivity and business performance by avoiding disruption of work and ensuring zero downtime."
    },
    {
    question: "Business process optimization – Smarter monitoring & control",
    answer:
        "A comprehensive monitoring capability allows authorized users to manage user sessions, such as who is logged in and activities in progress. Also, with the ability to track, monitor user activities /sessions and even disconnect users, if required, it helps to optimize processes or system usage for enhanced productivity."
      }
  ];
  